module.exports = __webpack_public_path__ + "media/theme/icon__menu-22cb91a6.png";